import * as yup from 'yup';
import 'yup-phone';
import { i18n } from '@lt/localization';
import { FormFields } from './types';
import { createPhoneValidator } from './components/phoneValidationUtils';

export const phoneValidationSchema = (
  phoneMask?: string,
  countryCode?: string,
) =>
  yup.object().shape({
    [FormFields.LoginByPhone]: createPhoneValidator(phoneMask, countryCode),
  });

export const emailValidationSchema = yup.object({
  [FormFields.LoginByEmail]: yup
    .string()
    .matches(
      /^(([^<>()[\]\\/*=.,;:\s@"]{1,50}(\.[^<>()[\]\\/*=.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9а-яА-ЯёЁ-]+\.)+[a-zA-Zа-яА-ЯёЁ]{2,}))$/,
      i18n.t('checkout.registrationForm.email.inputError'),
    )
    .required(i18n.t('checkout.registrationForm.email.required')),
});
